module.exports = __webpack_public_path__ + "img/g3.ecdc7f5c.jpg";